/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_Output_ValueInputs */

const en_landing_why_output_value = /** @type {(inputs: Landing_Why_Output_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Native 2K`)
};

const zh_landing_why_output_value = /** @type {(inputs: Landing_Why_Output_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原生 2K`)
};

/**
* | output |
* | --- |
* | "Native 2K" |
*
* @param {Landing_Why_Output_ValueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_output_value = /** @type {((inputs?: Landing_Why_Output_ValueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_Output_ValueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_output_value(inputs)
	return zh_landing_why_output_value(inputs)
});
export { landing_why_output_value as "landing.why.output_value" }